import PageHeader from "../supplier-responses/page-header/page-header";
import Header from "./header/header";
import Table from "./table/table";

export default function SupplierResponsesAllPage() {
  return (
    <div>
      <PageHeader breadcrumbs={["Supplier Responses"]} />
      <Header />
      <Table />
    </div>
  );
}
